import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/core'
import SydButton from '../../../../../../commonDesign/Button'
import { postNamedQuery } from '../../../../../../../service'
import { useEditor } from './EditorContext'
import VariablesForm from './VariablesForm'
import ResultsView from './ResultsView'

const useStyles = makeStyles(() => ({
  panel: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0
  },
  header: {
    flexShrink: 0,
    padding: '8px 12px',
    borderBottom: '1px solid var(--color-neutral-200)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: 'var(--text-size-xs)',
    fontWeight: 'var(--text-weight-bold)',
    color: 'var(--color-neutral-500)',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    backgroundColor: 'var(--color-neutral-050)'
  },
  variablesWrap: {
    flexShrink: 0,
    maxHeight: '40%',
    overflowY: 'auto',
    borderBottom: '1px solid var(--color-neutral-200)'
  },
  resultsWrap: {
    flex: 1,
    minHeight: 0
  }
}))

function TestPanel () {
  const classes = useStyles()
  const {
    variables, setVariables,
    pipelineParse,
    testResult, setTestResult,
    testError, setTestError,
    testRunning, setTestRunning
  } = useEditor()

  const runTest = useCallback(async () => {
    if (pipelineParse.error) {
      setTestError(`Pipeline JSON parse error: ${pipelineParse.error}`)
      setTestResult(null)
      return
    }
    setTestRunning(true)
    setTestError(null)
    setTestResult(null)
    try {
      const components = Array.isArray(pipelineParse.value)
        ? pipelineParse.value
        : (pipelineParse.value?.components || [])
      const r = await postNamedQuery('coreData', 'execute-data-pipeline', {
        pipeline: components,
        variables
      })
      setTestResult(r?.data ?? null)
    } catch (err) {
      setTestError(err?.response?.data?.message || err.message || 'Execution failed')
    } finally {
      setTestRunning(false)
    }
  }, [pipelineParse, variables, setTestRunning, setTestError, setTestResult])

  return (
    <div className={classes.panel}>
      <div className={classes.header}>
        <span>Test</span>
        <SydButton
          size='xs'
          variant='secondary'
          icon='arrowForward'
          onClick={runTest}
          processing={testRunning}
          disabled={testRunning || !!pipelineParse.error}
        >
          Run
        </SydButton>
      </div>
      <div className={classes.variablesWrap}>
        <VariablesForm value={variables} onChange={setVariables} />
      </div>
      <div className={classes.resultsWrap}>
        <ResultsView result={testResult} error={testError} />
      </div>
    </div>
  )
}

export default TestPanel
